import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppFeedbackPage } from './app-feedback';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppFeedbackPage,
  ],
  imports: [
    IonicPageModule.forChild(AppFeedbackPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppFeedbackPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-feedback/app-feedback.module.ts